import { useGoalsData } from './useGoalsData.js'

/**
 * usePillarData — read the goals for a specific pillar by name.
 *
 * Generic replacement for the per-pillar hooks (useRevenueGoal, etc.).
 * Every pillar derives from the same `useGoalsData` cache, so switching
 * pillars doesn't trigger a refetch.
 *
 * Returns:
 *   pillar    — the pillar object (or null if not found)
 *   goals     — array of goals for this pillar (or empty array)
 *   isLoading / isFetching / error — standard query flags
 *
 * Usage:
 *   const { goals, pillar, isLoading } = usePillarData('EO Buyouts')
 */
export function usePillarData(pillarName) {
  const { data, isLoading, isFetching, error } = useGoalsData()
  const pillar = data?.find((p) => p.pillar === pillarName) || null
  const goals = pillar?.goals || []
  return { pillar, goals, isLoading, isFetching, error }
}
